import React from "react";
import { Form } from "react-bootstrap";

type MasterTextFieldProps = {
  label: string;
  name: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  placeholder?: string;
  invalidMessage?: string;
};

export default function MasterTextField({
  label,
  name,
  value,
  onChange,
  required = false,
  placeholder,
  invalidMessage,
}: MasterTextFieldProps) {
  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        required={required}
        size="sm"
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      {invalidMessage ? (
        <Form.Control.Feedback type="invalid">{invalidMessage}</Form.Control.Feedback>
      ) : null}
    </Form.Group>
  );
}
